export default __webpack_public_path__ + "static/media/leaf1.b21c6672.svg";